import { render, staticRenderFns } from "./NavPane.vue?vue&type=template&id=0b46ff66&"
import script from "./NavPane.vue?vue&type=script&lang=js&"
export * from "./NavPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports